import $ from "jquery";
import * as _ from "underscore";

const handlers = {}; // hash of <PAGE>_<KEYCODE>(_<MODIFIER>) to handler functions
const keyDownHandlers = {};

export const keyCodes = {
  backspace: 8,
  enter: 13,
  escape: 27,
  space: 32,
  left: 37,
  right: 39,
  up: 38,
  down: 40,
  forwardSlash: 191,
};

// codes that don't respond to keyUp
const keyDownCodes = [
  8, // backspace
  27, // escape
  37,
  38,
  39,
  40, // cursor keys
];

const modifierKeys = ["ctrl", "alt", "meta"];

type ModifierKey = (typeof modifierKeys)[number];

const handle = (event, keyDown) => {
  const page = $("body").attr("id");
  let handleId = (page || "") + "_" + event.which;

  _.every(modifierKeys, (key) => {
    if (event[key + "Key"]) {
      handleId += "_" + key;
      return false;
    }
    return true;
  });

  let handler = keyDown ? keyDownHandlers[handleId] : handlers[handleId];
  if (!handler) {
    handler = handlers["*_" + event.which];
  }
  if (!handler) {
    return;
  }

  if (!handler.worksEverywhere) {
    // don't grab cursor key events from these elements
    if ($(event.target).closest("input, textarea").length > 0) {
      return;
    }
  }

  handler.handler(event);
};

export const registerHandler = (
  page: string,
  keyCode: number,
  handler: (event?: Event, keydown?: boolean) => void,
  worksEverywhere?: boolean /* works in input/textarea */,
  keyDown?: boolean,
  modifierKey?: ModifierKey
) => {
  let handleId = page + "_" + keyCode;

  if (modifierKey) {
    handleId += "_" + modifierKey;
  }

  if (keyDown || keyDownCodes.indexOf(keyCode) !== -1) {
    keyDownHandlers[handleId] = {
      handler: handler,
      worksEverywhere: worksEverywhere,
    };
  } else {
    handlers[handleId] = {
      handler: handler,
      worksEverywhere: worksEverywhere,
    };
  }
};

export const unregisterHandler = (
  page: string,
  keyCode: number,
  keyDown?: boolean,
  modifierKey?: ModifierKey
) => {
  const handleId =
    page + "_" + keyCode + (modifierKey ? "_" + modifierKey : "");

  if (keyDown) {
    delete keyDownHandlers[handleId];
  } else {
    delete handlers[handleId];
  }
};

$(document).ready(() => {
  // keypress is not triggered if the event is captured in a child element, e.g. in an <input>
  $(document).keypress((event) => {
    handle(event, false);
  });

  // keydown is triggered on window.document even when an <input> element has focus
  $(document).keydown((event) => {
    handle(event, true);
  });
});
